export enum RoundOffOption {
  ROUND_DOWN_TO_NEAR = 'ROUND_DOWN_TO_NEAR',
  ROUND_UP_TO_NEAR = 'ROUND_UP_TO_NEAR',
  ALWAYS_ROUND_DOWN_TO_NEAR = 'ALWAYS_ROUND_DOWN_TO_NEAR',
  ALWAYS_ROUND_UP_TO_NEAR = 'ALWAYS_ROUND_UP_TO_NEAR',
}

export enum RoundOffValue {
  ONE = '1',
  ZERO_POINT_FIVE = '0.5',
  ZERO_POINT_TWO_FIVE = '0.25',
  ZERO_POINT_ONE = '0.1',
  ZERO_POINT_ZERO_FIVE = '0.05',
}

export enum DayOfWeek {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  ALL = 'ALL',
}

export enum TipCalculation {
  BEFORE_TAX = 'BEFORE_TAX',
  AFTER_TAX = 'AFTER_TAX',
}

export enum EmailType {
  DAILY_SALES_SUMMARY = 'DAILY_SALES_SUMMARY',
  LOW_INVENTORY_STOCK = 'LOW_INVENTORY_STOCK',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  PAYOUT_SUMMARY = 'PAYOUT_SUMMARY',
  SHIFT_SUMMARY = 'SHIFT_SUMMARY',
}

export enum EmailReceipt {
  NONE = 'NONE',
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export enum TableShape {
  RECTANGLE = 'RECTANGLE',
  SQUARE = 'SQUARE',
  ROUND = 'ROUND',
}

export enum TableStatus {
  YOUR_TABLE = 'YOUR_TABLE',
  IN_USE = 'IN_USE',
  SEATED = 'SEATED',
  OCCUPIED = 'OCCUPIED',
  DONE_SOON = 'DONE_SOON',
  AVAILABLE = 'AVAILABLE',
  INACTIVE = 'INACTIVE',
  MULTI_USE = 'MULTI_USE',
}

export enum ReceiptPrintOption {
  PROMPT = 'PROMPT',
  AUTO = 'AUTO',
  NO_PRINT = 'NO_PRINT',
}

export enum SignatureAndTippingOption {
  TIP_AND_SIGN_PAYMENT_SCREEN = 'TIP_AND_SIGN_PAYMENT_SCREEN',
  TIP_AND_SIGN_PAYMENT_DEVICE = 'TIP_AND_SIGN_PAYMENT_DEVICE',
  TIP_AND_SIGN_RECEIPT = 'TIP_AND_SIGN_RECEIPT',
  NONE = 'NONE',
}

export enum AppScreen {
  LOGIN = 'LOGIN',
  ORDER_HISTORY = 'ORDER_HISTORY',
  FLOOR_VIEW = 'FLOOR_VIEW',
  NEW_ORDER = 'NEW_ORDER',
  OPEN_ORDER = 'OPEN_ORDER',
  ONLINE_ORDER = 'ONLINE_ORDER',
}

export enum DeviceProfileStatus {
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
}

export enum PrinterType {
  BLUETOOTH = 'BLUETOOTH',
  LAN = 'LAN',
  WIFI = 'WIFI',
  VIRTUAL = 'VIRTUAL',
  SERIAL = 'SERIAL',
  USB = 'USB',
  SUNMI = 'SUNMI',
}

export enum TableNamingMethods {
  GENERATE_AUTOMATICALLY = 'Generate Automatically',
  CUSTOM = 'Custom',
}

export enum PrinterBrand {
  EPSON = 'EPSON',
  EPSON_WEB = 'EPSON_WEB',
  STAR = 'STAR',
  OTHER = 'OTHER',
}

export enum PrinterSeries {
  TM_M30 = 'TM_M30',
  TM_M30II = 'TM_M30II',
  TM_U220 = 'TM_U220',
  TM_T82 = 'TM_T82',
  TM_L90 = 'TM_L90',
}

export enum CustomerDisplayImageType {
  orgLogo = 'orgLogo',
  backgroundImage = 'backgroundImage',
  promoImages = 'promoImages',
}

export enum OrderIdentifier {
  TOKEN_ID = 'TOKEN_ID',
  CUSTOMER_NAME = 'CUSTOMER_NAME',
}

export enum MediaType {
  IMAGE = 'image',
  GIF = 'gif',
}

export enum DeviceProfileDisplayScreen {
  IDLE = 'idleScreen',
  CART = 'cartScreen',
}

export enum AssetType {
  LOGO = 'logo',
  PROMO = 'promo',
}
